import { createSlice } from "@reduxjs/toolkit";
import api from '../Components/_helpers/api';

export const ndeSlice = createSlice({
  name: "nde",
  initialState: {
    data: {data:[]},
    currentFilters: {},
    isLoading: true,
    error: "",
  },
  reducers: {
    requestDTEs: (state, action) => {
      state.isLoading = true;
      state.currentFilters = action.payload;
    },
    requestDTEsSuccess: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    requestDTEsFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    setError: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    }
  },
});

export const { requestDTEs, requestDTEsSuccess, requestDTEsFailure, setError } = ndeSlice.actions;

//Thunks
export const requestDTEsAsync = (payload) => (dispatch) => {
  let filters = payload || {};
  dispatch(requestDTEs(filters));

  api.post('/NDE/DTE', payload).then((data) => {
    dispatch(requestDTEsSuccess(data.data));
  }).catch(e => {
    console.log(e);
    dispatch(requestDTEsFailure(e));
  });
};

//Selector
export const selectData = (state) => state.nde.data;
export const selectIsLoading = (state) => state.nde.isLoading;
export const selectError = (state) => state.nde.error;
export const selectCurrentFilters = (state) => state.nde.currentFilters;

export default ndeSlice.reducer;
